/**
 * Normalize an Indian mobile number to a consistent 10-digit form
 * before hashing for blind-index lookups.
 */
export function normalizeIndianMobile(raw: string): string {
  // Remove spaces, dashes, dots, brackets
  let digits = raw.replace(/[\s\-.()+]/g, '')

  // Strip country code: +91 or 0091 or leading 0
  if (digits.startsWith('91') && digits.length === 12) {
    digits = digits.slice(2)
  } else if (digits.startsWith('0') && digits.length === 11) {
    digits = digits.slice(1)
  }

  return digits  // 10-digit result; caller validates length
}
